var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-button',{class:_vm.classes,attrs:{"type":_vm.type,"variant":_vm.variant,"size":_vm.size,"disabled":_vm.disabled}},[(_vm.loading)?_c('b-spinner',{style:({
      width: '1em',
      height: '1em',
      marginRight: '.25em'
    })}):_vm._e(),_vm._t("default",function(){return [_c('i18n',{attrs:{"path":"vouchercategory.redeemVoucher"}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }